import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminUndoTrashIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="m12.957 3.333-.834-.833H7.957l-.834.833H4.207V5h11.666V3.333h-2.916Zm-7.917 12.5c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667v-10h-10v10Zm1.667-4.166V7.5h6.666v8.333H6.707v-4.166ZM8.373 15h3.334v-3.333h1.666L10.04 8.333l-3.333 3.334h1.666V15Z" />
  </Icon>
);

export default memo(AdminUndoTrashIcon);
